module.exports = __webpack_public_path__ + "img/left1.2f5867e0.png";